const Colors = {
  primary: '#3C1149',
  secondary: '#6D4C77',
  mainText: '#454552',
  lightText: '#EBD7F3',
  black: '#000000',
  orange: '#ECA100',
  white: '#ffffff',
  grey: '#454552',
  lightGrey: '#E5E8EB',
  disabled: '#f1f1f1',
  disabledHover: '#CCD2D7',
  lightBackground: '#EBD6F3',
  success: '#D1E7DD',
  error: '#f52235'
};

const FontSize = {
  logo: '32px',
  normal: '16px',
  medium: '12px',
  small: '10px',
  title: '22px',
  subTitle: '18px',
  largeIcon: '45px',
  icon: '34px',
  mdIcon: '24px',
  smallIcon: '17px'
};

const FontWeight = {
  normal: '400',
  strong: '700'
};

const LineHeight = {
  normal: '1',
  higher: '1.5',
  double: '2'
};

const space = 2;
type SpacingValue = number | string;

const Spacing = (...values: SpacingValue[]): string =>
  values.map((value) => (typeof value === 'number' ? `${value * space}px` : value)).join(' ');

export { Colors, FontSize, FontWeight, LineHeight, Spacing };
